import { useContext } from 'react';
import { styled } from "@mui/material";
import { Field, FormikProvider, FormikValues, useFormik } from "formik";
import { useMutation, useQueryClient } from '@tanstack/react-query';
import Button from "../../../../customs/Button";
import Input from "../../../../customs/FormInput";
import Select from "../../../../customs/SelectInput";
import { NotificationContext } from '../../../../providers/notification';
import apiCall from '../../../../utils/apiCall';

interface Payload {
    RouteName: string;
}

interface ComponentProps{
    handleClose: () => void;
    id: number;
    routeName: string;
}

const EditRouteContent = ({id, routeName, handleClose}: ComponentProps) => {
    const { showNotification } = useContext(NotificationContext);
    const queryClient = useQueryClient();

    const updateRoute = async (data: Payload) => {
        return await(apiCall().put(`/Routes/${id}`, data));
    };

    const updateRouteMutation = useMutation(['update-route'], updateRoute, {retry: 0});

    const updateRouteHandler = async (values: FormikValues) => {
        const payload: Payload = {
            RouteName: values?.name,
        };

        try {
            await updateRouteMutation.mutateAsync(payload, {
                onSuccess: () => {
                    showNotification({
                        type: 'success',
                        message: 'Membership Route Successfully Updated'
                    });
                    queryClient.refetchQueries(['get-all-routes']);
                }
            })
        } catch(error: any) {
            showNotification({
                type: 'error',
                message: error?.response?.data?.Message || error?.message,
            })
        }
    }


    const formik = useFormik<FormikValues>({
        initialValues: {
            name: routeName || ''
        },
        onSubmit: (values) => {
            updateRouteHandler(values);
        }
    })

    return (
        <FormikProvider value={formik}>
            <form onSubmit={formik.handleSubmit}>
                <FormWrapper>
                    <Field 
                        name='name'
                        type='text'
                        as={Input}
                        label='Name'
                        placeholder='Name'
                    />
                    {/* <Field 
                        name='status'
                        type='text'
                        as={Select}
                        label='Status'
                    /> */}
                </FormWrapper>
                <ButtonWrapper>
                    <ButtonContainer>
                        <StyledButton text='Cancel' onClick={handleClose}/>
                        <StyledButton 
                            type="submit" 
                            text={updateRouteMutation.isLoading ? 'Updating' : 'Edit'}
                            disabled={updateRouteMutation.isLoading}
                        />
                    </ButtonContainer>
                </ButtonWrapper>
            </form>
        </FormikProvider>
    )
};

export default EditRouteContent;

const FormWrapper = styled('div')`
    margin-inline: 3.5rem;
`

const ButtonWrapper = styled('div')`
    display: flex;
    justify-content: flex-end;
    margin-block: 2.5rem;
    padding-inline: 3.5rem;
`

const ButtonContainer = styled('div')`
    display: flex;
    gap: 2rem;
`

const StyledButton = styled(Button)`
    padding-block: 1rem;
    padding-inline: 2rem;
`